import * as React from "react";

export const FollowersIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 60 60"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path
            d="M35 20.498c0 5.513-4.485 10-10 10-5.512 0-10-4.487-10-10 0-5.512 4.485-10 10-10s10 4.488 10 10Z"
            fill="currentColor"
            stroke="none"
        />
        <path
            d="M5 50.498v-2.5c0-8.832 8.225-15 20-15 11.778 0 20 6.168 20 15v2.5Z"
            fill="currentColor"
            stroke="none"
        />
        <path
            d="M50 50.498h5v-2.5c0-6.407-4.326-11.411-11.197-13.677C47.655 37.765 50 42.498 50 47.998Z"
            fill="currentColor"
            stroke="none"
        />
        <path
            d="M37.209 30.252c4.455-1.008 7.791-5 7.791-9.754 0-5.092-3.827-9.31-8.757-9.923A14.94 14.94 0 0 1 40 20.498c0 3.607-1.278 6.92-3.406 9.51.206.079.41.16.614.244Z"
            fill="currentColor"
            stroke="none"
        />
    </svg>
);